import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { LoadScript } from '@react-google-maps/api';
import initAuth0 from '@/shared/components/account/auth/withAuth0';
import TimepickerStyles from '@/shared/components/form/date-pickers/timepickerStyles';
import Loading from '@/shared/components/Loading';
import WalletConnectProvider from '@/shared/components/account/auth/WalletConnect';
import { Toaster } from 'react-hot-toast';
import CryptoJS from 'crypto-js';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import { config as i18nextConfig } from '../../translations';
import GlobalStyles from './globalStyles';
import RechartStyles from './rechartStyles';
import NotificationStyles from './notificationStyles';
import CalendarStyles from './calendarStyles';
import AppContextProvider from '../../context';
import { AuthContext } from '../../context/AuthContext';
import { PermissionContext } from '../../context/PermissionContext';
import Footer from '../Admin/Footer/Footer';

i18n.init(i18nextConfig);

const ThemeComponent = ({
  children,
}) => {
  const {
    mode, direction, shadow, border,
  } = useSelector(state => ({
    mode: state.theme.className,
    direction: state.rtl.direction,
    shadow: state.shadow.className,
    border: state.border.className,
  }));

  const theme = createTheme({
    palette: {
      type: mode,
    },
  });

  const {
 apiGlobal, userid, setUserId, username, 
    setUsername, 
} = useContext(AuthContext);
  const { setPermissionsAccess, permissionUpdate } = useContext(PermissionContext);

  useEffect(() => {
    const encryptedPermissions = localStorage.getItem('permissions');
    if (encryptedPermissions) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          encryptedPermissions,
          'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
        );
        const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);

        if (decryptedPermissionsString) {
          const permissionsAccess = JSON.parse(decryptedPermissionsString);
          setPermissionsAccess(permissionsAccess);
        }
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  }, []); // Runs on initial render and every reload


  // useEffect(() => {
  //   const navigationEntries = performance.getEntriesByType('navigation');
  //   const navigationType = navigationEntries.length > 0 ? navigationEntries[0].type : 'navigate';

  //   if (navigationType === 'reload') {
  //     const encryptedPermissions = localStorage.getItem('permissions');
  //     if (encryptedPermissions) {
  //       try {
  //         const bytes = CryptoJS.AES.decrypt(
  //           encryptedPermissions,
  //           'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
  //         );
  //         const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);

  //         if (decryptedPermissionsString) {
  //           const permissionsAccess = JSON.parse(decryptedPermissionsString);
  //           setPermissionsAccess(permissionsAccess);
  //         }
  //       } catch (error) {
  //         console.error('Decryption error:', error);
  //       }
  //     }
  //   } else {
  //     console.log('Page was loaded normally');
  //   }
  // }, []);


  // const fetchPermissions = async () => {
  //   try {
  //     const response = await fetch(`${apiGlobal}/admin_permission.php?id=${userid}`);
  //     const data = await response.json();

  //     console.log('Fetched Permissions:', data);
  //     if (data.status && data.message === 'Success') {
  //       const permissions = data.data[0].permission;
  //       setPermissionsAccess(permissions);
  //       const permissionsString = JSON.stringify(permissions);
  //       const encryptedPermissions = CryptoJS.AES
  //       .encrypt(permissionsString, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2').toString();
  //       localStorage.setItem('permissions', encryptedPermissions);
  //       console.log('fetch permisssion function called');
  //     } else {
  //       setPermissionsAccess([]);
  //       localStorage.removeItem('permissions');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching permissions:', error);
  //     setPermissionsAccess([]);
  //     localStorage.removeItem('permissions');
  //   }
  // };

  // useEffect(() => {
  //   const encryptedPermissions = localStorage.getItem('permissions');
   
  //   if (userid) {
  //     console.log('No stored permissions, fetching from API');
  //     fetchPermissions();
  //   } else if (encryptedPermissions) {
  //     console.log('Loaded encrypted permissions from localStorage');
  //     const bytes = CryptoJS.AES
  //     .decrypt(encryptedPermissions, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
  //     const decryptedPermissionsString = bytes.toString(CryptoJS.enc.Utf8);
    
  //     if (decryptedPermissionsString) {
  //       const permissionsAccess = JSON.parse(decryptedPermissionsString);
  //       console.log('Decrypted permissions:', permissionsAccess);
  //       setPermissionsAccess(permissionsAccess);
  //     } else {
  //       console.log('Failed to decrypt permissions');
  //     }
  //   } else {
  //     console.log('No permissions found in localStorage');
  //   }

  //   // if (storedPermissions) {
  //   //   console.log('Loaded permissions from localStorage');
  //   //   setPermissionsAccess(JSON.parse(storedPermissions));
  //   // } else if (userid) {
  //   //   console.log('No stored permissions, fetching from API');
  //   //   fetchPermissions();
  //   // }
  // }, [userid, permissionUpdate]);

  useEffect(() => {
    if (!userid) { // Only run the effect if userId is not set yet
      // Decrypt and retrieve the user ID from localStorage
      const encryptedData = localStorage.getItem('userid');
      if (encryptedData) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
        setUserId(decryptedUserId); // Set the userId state
      }
    }
    if (!username) { // Only run the effect if userId is not set yet
      // Decrypt and retrieve the user ID from localStorage
      const encryptedData = localStorage.getItem('userName');
      if (encryptedData) {
        const bytes = CryptoJS.AES.decrypt(encryptedData, 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2');
        const decryptedUsername = bytes.toString(CryptoJS.enc.Utf8);
        setUsername(decryptedUsername); // Set the userId state
      }
    }
  }, [userid, username]); // Only run the effect when userId is null or undefined

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider
        theme={{
          mode,
          direction,
          shadow,
          border,
        }}
      >
        <GlobalStyles />
        <NotificationStyles />
        <RechartStyles />
        <TimepickerStyles />
        <CalendarStyles />
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

const ConnectedThemeComponent = ThemeComponent;

const App = () => {
  useEffect(() => {
    window.addEventListener('load', initAuth0);
  }, []);

   
  
// basename="/bitVise"
  return (
    <AppContextProvider>
      <Provider store={store}>
        <BrowserRouter>
          <ConnectedThemeComponent>
            <LoadScript
              loadingElement={<Loading loading />}
              googleMapsApiKey=""
            >
              <ScrollToTop>
                <Router />
                <Footer />
                <Toaster position="top-right" reverseOrder={false} />
              </ScrollToTop>
            
            </LoadScript>
          </ConnectedThemeComponent>
        </BrowserRouter>
      </Provider>
    
    </AppContextProvider>
    
  );
};

export default App;
